import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material';
import { ReferralService } from '../../services/referral.service';
import { FormBuilder } from '@angular/forms';
import { map } from 'rxjs/operators';

@Component({
  selector: 'kt-my-referral-reason-dialog',
  templateUrl: './my-referral-reason-dialog.component.html',
  styleUrls: ['./my-referral-reason-dialog.component.scss']
})
export class MyReferralReasonDialogComponent implements OnInit {

  myReferralId: any;
  reasons: any;

  constructor(
    private fb: FormBuilder,
    private referralService: ReferralService,
    private dialogRef: MatDialogRef<MyReferralReasonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: any
  ) {dialogRef.disableClose = true;}

  ngOnInit() {
    this.myReferralId = this._data.element.Id;
    this.referralService.getReasons(this.myReferralId).pipe(map(res => {
      this.reasons = res['data'];
    }))
    .subscribe();
  }

  close() {
    this.dialogRef.close();
  }
  
}
